module.exports = function() {
  return new Worker(__webpack_public_path__ + "2599a015ef601c4a8433.worker.js");
};